module.exports = __webpack_public_path__ + "img/contactIcon.5945d159.svg";